module.exports = __webpack_public_path__ + "img/laconsulta_slogan.77d742c3.png";